<div id="main">

  <div class="modal-header">
    <h4 class="modal-title">{{projectName}} - {{"SUBSCRIPTION_SENCEIVE" | translate}}</h4>
    <button type="button" class="close" aria-label="Close" id="close" mat-dialog-close>
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body formModal">

    <app-progressbar *ngIf="showSpinner"></app-progressbar>
    <mat-horizontal-stepper [linear]="true" #stepper>
      <mat-step [stepControl]="senceiveSubscriptionForm">
        <form [formGroup]="senceiveSubscriptionForm">
          <ng-template matStepLabel>{{'INFORMATION' | translate}}</ng-template>

          <mat-form-field>
            <input matInput [placeholder]="('ID' | translate) + ' SENCEIVE'" formControlName="senceiveProjectId"
                   required
                   autocomplete="new-password">
            <mat-error *ngIf="senceiveProjectId.invalid">{{errorSenceiveProjectId}}</mat-error>
          </mat-form-field>

          <mat-form-field>
            <input matInput [placeholder]="('USER' | translate ) + ' SENCEIVE'" formControlName="senceiveUser" required
                   autocomplete="new-password">
            <mat-error *ngIf="senceiveUser.invalid">{{errorSenceiveUser}}</mat-error>
          </mat-form-field>

          <mat-form-field>
            <input matInput [placeholder]="('PASSWORD' | translate ) + ' SENCEIVE'" formControlName="senceivePassword"
                   required
                   type="password" autocomplete="new-password">
            <mat-error *ngIf="senceivePassword.invalid">{{errorSenceivePassword}}</mat-error>
          </mat-form-field>
          <p>{{"8_DAYS_RETRIEVING_SPECIAL_SUBSCRIPTION" | translate}}</p>

          <br/>
          <div>
            <button class="btn btn-info" mat-button matStepperNext [innerHTML]="'NEXT_BUTTON' | translate">
              Next
            </button>
          </div>
        </form>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>{{'CHECK_SAVE' | translate}}</ng-template>
        <div *ngIf="senceiveSubscriptionForm">
          <div><b [innerHtml]="'INFORMATION' | translate"></b></div>
          <mat-form-field class="readonly">
            <input matInput [placeholder]="('ID' | translate) + ' SENCEIVE'"
                   [value]="senceiveSubscriptionForm.value.senceiveProjectId"
                   [readonly]="true">

          </mat-form-field>
          <mat-form-field class="readonly">
            <input matInput [placeholder]="('USER' | translate) + ' SENCEIVE'"
                   [value]="senceiveSubscriptionForm.value.senceiveUser" [readonly]="true">
          </mat-form-field>
          <mat-form-field class="readonly">
            <input matInput [placeholder]="('PASSWORD' | translate) + ' SENCEIVE'"
                   [value]="senceiveSubscriptionForm.value.senceivePassword" [readonly]="true" type="password">
          </mat-form-field>
          <br/>
          <div>
            <button class="btn btn-info" mat-button matStepperPrevious [innerHTML]="'BACK_BUTTON' | translate">
              Back
            </button>
            <button type="button" class="btn btn-warning" (click)="postSenceiveSubscription()">
              <app-progressbar *ngIf="showSpinner"></app-progressbar>
              {{'SAVE'|translate}}
            </button>
          </div>

        </div>
      </mat-step>
    </mat-horizontal-stepper>


  </div>

</div>
